import { Modal } from "antd";
import React, { useState } from "react";
import SeloGrupoRequest from "../SeloGrupoRequest";
import { ModalStatusDelete } from "../../../Utils/modalStatus";

export const ModalDelete = ({ visible, onCancel, id, estadoSeloGrupo }) => {
  const [loading, setLoading] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);

  const deletarSeloGrupo = async () => {
    setLoading(true);
    try {
      const response = await SeloGrupoRequest.ExcluirSeloGrupo(id);
      if (response.status === 204) {
        estadoSeloGrupo((prevState) =>
          prevState.filter((item) => item.id !== id)
        );
        setOpenModalStatus(true);
        onCancel();
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        onOk={deletarSeloGrupo}
        confirmLoading={loading}
      >
        <text style={{ fontSize: 17, fontWeight: "500" }}>
          Deseja deletar este Selo Grupo?
        </text>
      </Modal>

      <ModalStatusDelete
        onCancel={() => setOpenModalStatus(false)}
        visible={openModalStatus}
      />
    </>
  );
};
